import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

export const getInvitesCountKey = (): UseDataQuery['queryKey'] => ['invites/count'];
